import { render } from "./taskResourceItem.vue?vue&type=template&id=2d9e6808"
import script from "./taskResourceItem.vue?vue&type=script&lang=js"
export * from "./taskResourceItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./styles.less?vue&type=style&index=0&module=true&lang=less&external"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__